import { render } from "./AddPickupPoint.vue?vue&type=template&id=0267f06d&scoped=true"
import script from "./AddPickupPoint.vue?vue&type=script&lang=js"
export * from "./AddPickupPoint.vue?vue&type=script&lang=js"

import "./AddPickupPoint.vue?vue&type=style&index=0&id=0267f06d&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0267f06d"]])

export default __exports__